export default "__VITE_ASSET__NxCs_eYr__"